import { useEffect, useRef, useState } from "react";
import AgGridTable from "../../utilities/AgGridTable";
import { useCallback } from "react";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import uploadSingleFilePopup from "./uploadSingleFilePopup";
import { Button, Grid, Stack } from "@mui/material";
import yearSelectionEditor, { docTextCellEditor } from "./SelectionEditorComponent";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import OAuthService from "src/app/auth/services/oAuthService";

const DocumentTab = (props) => {
    const [documentRowData, setDocumentRowData] = useState([]);
    const [updateData, setUpdateData] = useState([]);
    const [successMsg, setSuccessMsg] = useState();
    const [deletedRow, setDeletedRow] = useState([]);
    const [dataChanged, setDataChanged] = useState(false);
    const [saveDisabled, setSaveDisabled] = useState(false);
    const [errorMsg, setErrorMsg] = useState();
    const [companyId, setCompanyId] = useState(props.companyCode)
    const [documentColumnDef, setDocumentColumnDef] = useState([
        { field: 'docType', enableRowGroup: true, cellEditor: docTextCellEditor },
        { field: 'year', enableRowGroup: true, cellEditor: yearSelectionEditor },
        { field: 'fileName', enableRowGroup: true, cellEditor: uploadSingleFilePopup },
        { field: 'file', hide: true, editable: false },
    ]);
    const gridRef = useRef()
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companyInfo}`;
    const uploadUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.fileUpload}`;
    const downloadUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.fileDownload}`;

    const handleSubmitDocument = async () => {
        setSuccessMsg('')
        if (saveDisabled) {
            setErrorMsg("Please fill all fields. Blank data are not allowed.")
        } else {
            try {
                if (deletedRow.length > 0) {
                    await Promise.all(deletedRow.map(async (deleteData) => {
                        
                        delete deleteData.file;
                        deleteData.companyId = { id: Number(companyId) }
                        await OAuthService.deleteData(url + '/deleteDocuments', '', deleteData);
                    }))
                    setSuccessMsg("Files Updated successfully");
                    setSaveDisabled(true)
                }
                let updatedData = []
                await Promise.all(documentRowData.map(async (row) => {
                    if (row.id) {
                        const oldData = updateData.filter((edit) => edit.id === row.id);
                        if (oldData.length > 0 && (JSON.stringify(row) !== JSON.stringify(oldData[0]))) {
                            if (row?.file && row?.file?.length > 0) {
                                const formData = new FormData();
                                formData.append('file', row.file);

                                const uploadData = await OAuthService.uploadFile(uploadUrl, formData);
                                if (uploadData.data) {
                                    if (uploadData.data.error) {
                                        setErrorMsg(uploadData.data.error);
                                    } else {
                                        row.path = uploadData.data.downloadUri;

                                    }
                                }
                            }
                            row.companyId = { id: Number(companyId) };
                            delete row.file;
                            updatedData.push(row);
                            await OAuthService.deleteData(url + '/deleteDocuments', '', row);
                        }
                    } else {
                        if (row.file) {
                            const formData = new FormData();
                            formData.append('file', row.file);

                            const uploadData = await OAuthService.uploadFile(uploadUrl, formData);
                            if (uploadData.data) {
                                if (uploadData.data.error) {
                                    setErrorMsg(uploadData.data.error);
                                } else {
                                    row.path = uploadData.data.downloadUri;

                                }
                            }
                        }
                        row.companyId = { id: Number(companyId) };
                        delete row.file;
                        updatedData.push(row);
                    }
                    return row;
                }))
                if (!errorMsg) {
                    if (updatedData.length > 0) {
                        const saveDoc = await OAuthService.addData(url + '/saveDocuments', updatedData);
                        if (saveDoc) {
                            setSuccessMsg("File Uploaded successfully")
                            setSaveDisabled(true)
                        }
                    }
                }
            } catch (error) {
                setErrorMsg(error?.response?.data?.errorMessage || error.message)
            }
        }
    }

    const getDocuments = async () => {
        try {
            if (companyId) {
                const docs = await OAuthService.getList(url + `/getDocuments?companyId=${companyId}`)

                if (docs?.data) {
                    const editData = docs.data.filter(data =>  data.deleted === false).map((data) => {
                        delete data.createdBy;
                        delete data.createdAt;
                        delete data.delete;
                        delete data.deleted;
                        delete data.updatedAt;
                        delete data.updatedBy;
                        return data
                    })
                    setDocumentRowData(editData);
                }
            }

        } catch (error) {

        }
    };

    useEffect(() => {
        if (props.companyCode) {
            setCompanyId(props.companyCode)
        }
    }, [props])

    useEffect(() => {
        getDocuments();
    }, [companyId])

    const onBtAdd = useCallback((event) => {
        const newRow = {
            "docType": '',
            "fileName": '',
            'year': '',
            'file': ''
        };

        const RowIndex = event?.node?.rowIndex ? event.node.rowIndex + 1 : 0;
        let index = documentRowData.findIndex((row) => row.id === event?.node?.data?.id);
        const nextIndex = index + 1;
        documentRowData.splice(nextIndex, 0, newRow);
        gridRef.current.api.applyTransaction({ add: [newRow], addIndex: nextIndex });
        gridRef.current.api.refreshCells();
        setTimeout(() => {
            gridRef.current.api.setFocusedCell(nextIndex, 'docType')
            gridRef.current.api.startEditingCell({
                rowIndex: nextIndex,
                colKey: 'docType',
            });
        }, 800);

    }, [documentRowData]);

    const onBtStartEditing = useCallback((event) => {
        const data = event?.node?.data;
        const index = event?.node?.rowIndex;
        gridRef.current.api.setFocusedCell(index, 'docType')
        gridRef.current.api.startEditingCell({
            rowIndex: index,
            colKey: 'docType',
        });

    }, [documentRowData]);

    const onBtDeleteRow = useCallback((event) => {
        const selectedRow = gridRef.current.api.getSelectedRows();
        documentRowData?.splice(event?.node?.rowIndex, 1);
        gridRef?.current?.api.applyTransaction({ remove: selectedRow });
        if (event.node.data.id) {
            deletedRow.push(event.node.data)
            setDeletedRow(deletedRow)
        }
        documentRowData.map((data) => {
            if (data.fileName === undefined || data.year === undefined || data.docType === undefined ||
                data.fileName === "" || data.year === "" || data.docType === "" ||
                data.fileName === null || data.year === null || data.docType === null) {
                setSaveDisabled(true);
            } else {
                setSaveDisabled(false);

            }
        });
        setDataChanged(true)

    }, [documentRowData]);


    useEffect(() => {
        props.setAllSuccessMsg(successMsg)
    }, [successMsg]);

    useEffect(() => {
        props.setAllErrorMsg(errorMsg)
    }, [errorMsg])

    const getContextMenuItems = useCallback((event) => {
        const result = [
            {
                name: "Add Document",
                icon: '<span><i class="material-icons style="font-size: 18px">perm_identity</i></span>',
                action: () => {
                    onBtAdd(event);
                },
            },
            {
                name: "Edit Document",
                icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
                action: () => {
                    onBtStartEditing(event);
                },
            },
            {
                name: "Delete Document",
                icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
                action: () => {
                    onBtDeleteRow(event);
                },
            },
            'separator',
            'export',
            'chartRange',
        ];

        return result

    }, [documentRowData]);

    const onRowValueChanged = useCallback(async (event) => {
        const { data } = event.node;
        setDataChanged(true)
        const model = {
            id: data.id ? data.id : null,
            file: data.file,
            fileName: data.fileName,
            year: data.year,
            path: data.path,
            docType: data.docType,
            rowIndex: event.node.rowIndex
        }
        if (updateData.filter(doc => doc.rowIndex === event.node.rowIndex).length > 0) {
            const updatedData = updateData.map((item) => {
                if (item.rowIndex === event.node.rowIndex) {
                    item.file = data.file;
                    item.fileName = data.fileName;
                    item.year = data.year;
                    item.path = data.path;
                    item.docType = data.docType;
                    item.category = data.category;
                }
                return item;
            })
            setUpdateData(updatedData);
        } else {
            setUpdateData([...updateData, model]);
        }

    }, [updateData])

    const onGridReady = useCallback(() => {

    }, [documentRowData]);

    useEffect(() => {
        documentRowData.map((data) => {
            if (data.fileName === undefined || data.year === undefined || data.docType === undefined ||
                data.fileName === "" || data.year === "" || data.docType === "" ||
                data.fileName === null || data.year === null || data.docType === null) {
                setSaveDisabled(true);
            } else {
                setSaveDisabled(false);

            }
        });
    }, [documentRowData]);

    const onCellValueChanged = useCallback((event) => {
        const { data } = event.node
        setDataChanged(true)
        const model = {
            id: data.id ? data.id : null,
            file: data.file,
            fileName: data.fileName,
            year: data.year,
            path: data.path,
            docType: data.docType,
            rowIndex: event.node.rowIndex
        }
        let allrows = [];
        if (updateData.filter(doc => doc.rowIndex === event.node.rowIndex).length > 0) {
            const updatedData = updateData.map((item) => {
                if (item.rowIndex === event.node.rowIndex) {
                    item.file = data.file;
                    item.fileName = data.fileName;
                    item.year = data.year;
                    item.path = data.path;
                    item.docType = data.docType;
                    item.category = data.category;
                }
                return item;
            })
            allrows = [...updatedData]
            setUpdateData(updatedData);
        } else {
            allrows = [...updateData, model]
            setUpdateData([...updateData, model]);
        }
        let saveState = '';
        if (allrows.length > 0) {
            allrows.map((data) => {
                if (data.fileName && data.year && data.docType) {
                        if (saveState !== true) {
                            saveState = false;
                        }
                } else {
                    saveState = true
                }
            });
        }
        if (saveState !== '') {
            setSaveDisabled(saveState)
        }
    }, [updateData])

    return (
        <>
            <Grid className="flex flex-row mb-10" justifyContent="flex-end" alignItems="flex-end">
                <Button variant="contained"
                    color="warning"
                    onClick={handleSubmitDocument}
                    disabled={dataChanged ? saveDisabled : true}
                >
                    <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
                </Button>
            </Grid>
            <Stack style={{ height: '500px' }}>
                <AgGridTable
                    columnDefs={documentColumnDef}
                    rowData={documentRowData}
                    onRowValueChanged={onRowValueChanged}
                    onCellValueChanged={onCellValueChanged}
                    gridRef={gridRef}
                    onGridReady={onGridReady}
                    editType={'fullRow'}
                    getContextMenuItems={getContextMenuItems}
                />
            </Stack>
        </>
    )
}

export default DocumentTab;